import { Link } from "react-router-dom";
import { CARRIER_COORDINATION as T } from "@/constants/testIds";
import { ArrowUpRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section id="final-cta" data-testid={T.finalCta} className="relative isolate overflow-hidden bg-white py-24">
      <div className="mx-auto max-w-6xl px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-3xl border border-slate-line bg-white p-10 shadow-card-lg sm:p-14">
          <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-blue-soft blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-blue-soft blur-3xl" />
          <div className="pointer-events-none absolute inset-0 bg-dot-grid opacity-40" />

          <div className="relative mx-auto max-w-2xl text-center">
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-blue-brand">Get Started</p>
            <h2 className="mt-4 text-3xl font-semibold text-navy sm:text-4xl lg:text-[46px] lg:leading-[1.08]">
              Coordinate Every Shipment.
              <br />
              <span className="text-slate-400">From One Workspace.</span>
            </h2>
            <p className="mx-auto mt-6 max-w-xl text-[15px] leading-relaxed text-slate-600 sm:text-base">
              Manage carriers, bookings, shipment schedules and freight operations through{" "}
              <span className="font-semibold text-navy">FreightIQ™</span>, the carrier coordination Workspace Product inside DeMaxtore.
            </p>

            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link
                to="/freightiq"
                data-testid={T.finalPrimaryCta}
                className="group inline-flex items-center gap-2 rounded-full bg-blue-brand px-5 py-3 text-sm font-medium text-white shadow-card transition hover:translate-y-[-1px] hover:shadow-card-lg"
                style={{ backgroundColor: "hsl(var(--blue))" }}
              >
                Explore FreightIQ™
                <ArrowUpRight className="h-4 w-4 transition group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
              <Link
                to="/workspace"
                data-testid={T.finalSecondaryCta}
                className="inline-flex items-center gap-2 rounded-full border border-slate-line bg-white px-5 py-3 text-sm font-medium text-navy shadow-sm transition hover:border-slate-300 hover:shadow-card"
              >
                Create Your Free Workspace
              </Link>
            </div>

            <p className="mt-6 text-[12.5px] text-slate-500">
              Carrier coordination. Booking visibility. One Workspace.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
